import { $httpChangiRecommends } from '@/core/api';
const state = {
    brands: [],
    brandsLoaded: false,
    brandsLoading: false,
};
const mutations = {
    setBrands(state, brands) {
        state.brands = brands;
    },
    setBrandsLoading(state, isLoading) {
        state.brandsLoading = isLoading;
    },
    setBrandsLoaded(state) {
        state.brandsLoaded = true;
    },
};
const getters = {};
const actions = {
    getBrands({ commit }) {
        commit('setBrandsLoading', true);
        $httpChangiRecommends.api
            .ChangiRecommendsAllBrands()
            .then((resp) => {
            commit('setBrands', resp.data);
        })
            .catch((err) => {
            console.error(err);
        })
            .finally(() => {
            commit('setBrandsLoading', false);
            commit('setBrandsLoaded');
        });
    },
};
export const brandsModule = {
    state,
    getters,
    mutations,
    actions,
    namespaced: true,
};
